export default __webpack_public_path__ + "media/images/Masto-F2-Musique-12e50ab1cbe1e783143d17ec92744c68.png";